export default __webpack_public_path__ + "static/media/yogabot_icon.4dd5cb5f.svg";